import { FC, useContext, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { Label, Preloader } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { USER_CLUBS } from 'auth/schema';
import { IUserClubsResponse } from 'auth/types';

import s from './CurrentClubCard.module.scss';
import { ICurrentClubCardProps } from './interfaces';

export const CurrentClubCard: FC<ICurrentClubCardProps> = ({ club }) => {
  const {
    data: { tokens },
  } = useContext(AuthContext);

  const { data: { userClubs } = {}, loading } = useQuery<IUserClubsResponse>(
    USER_CLUBS,
    {
      fetchPolicy: 'no-cache',
      skip: Boolean(club),
    }
  );

  const currentClub = useMemo(() => {
    const encodedToken = atob(tokens?.access_token?.split('.')[1] ?? '');
    const clubId = encodedToken ? JSON.parse(encodedToken)?.company_id : null;

    return userClubs?.find((club) => club.id === clubId) ?? club;
  }, [userClubs, tokens?.access_token, club]);

  return (
    <div className={s.container}>
      <Preloader loading={loading} small>
        <Label
          color="gray-primary"
          text={`ID: ${currentClub?.id}`}
          rounded
          size="m"
          className={s.id}
        />
        <span className={s.title} title={currentClub?.name}>
          {currentClub?.name}
        </span>
        <span className={s.address} title={currentClub?.address}>
          {currentClub?.address}
        </span>
      </Preloader>
    </div>
  );
};
